"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosJWTDecorator = void 0;
var axios_1 = require("axios");
var microsoftTeams = require("@microsoft/teams-js");
var AxiosJWTDecorator = /** @class */ (function () {
    function AxiosJWTDecorator() {
    }
    /**
    * Delete data
    * @param  {String} url Resource URI
    */
    AxiosJWTDecorator.prototype.delete = function (url, data, config, needAuthorizationHeader) {
        if (needAuthorizationHeader === void 0) { needAuthorizationHeader = true; }
        return __awaiter(this, void 0, void 0, function () {
            var config_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config_1 = axios_1.default.defaults;
                        if (!needAuthorizationHeader) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setupAuthorizationHeader(config_1)];
                    case 1:
                        config_1 = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (data) {
                            config_1.headers["Content-Type"] = 'application/json; charset=utf-8';
                            config_1.data = data;
                        }
                        return [4 /*yield*/, axios_1.default.delete(url, config_1)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        error_1 = _a.sent();
                        return [2 /*return*/, error_1.response];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Post data to API
    * @param  {String} url Resource URI
    * @param  {Object} data Request body data
    */
    AxiosJWTDecorator.prototype.post = function (url, data, config, needAuthorizationHeader, headerData) {
        if (needAuthorizationHeader === void 0) { needAuthorizationHeader = true; }
        return __awaiter(this, void 0, void 0, function () {
            var config_2, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config_2 = axios_1.default.defaults;
                        if (!needAuthorizationHeader) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setupAuthorizationHeader(config_2)];
                    case 1:
                        config_2 = _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, axios_1.default.post(url, data, config_2)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        error_2 = _a.sent();
                        return [2 /*return*/, error_2.response];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Update data
    * @param  {String} url Resource URI
    * @param  {Object} data Request body data
    */
    AxiosJWTDecorator.prototype.put = function (url, data, config, needAuthorizationHeader) {
        if (needAuthorizationHeader === void 0) { needAuthorizationHeader = true; }
        return __awaiter(this, void 0, void 0, function () {
            var error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!needAuthorizationHeader) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setupAuthorizationHeader(config)];
                    case 1:
                        config = _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, axios_1.default.put(url, data, config)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        error_3 = _a.sent();
                        return [2 /*return*/, error_3.response];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Update data with patch request
    * @param  {String} url Resource URI
    * @param  {Object} data Request body data
    */
    AxiosJWTDecorator.prototype.patch = function (url, data, config, needAuthorizationHeader) {
        if (needAuthorizationHeader === void 0) { needAuthorizationHeader = true; }
        return __awaiter(this, void 0, void 0, function () {
            var error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!needAuthorizationHeader) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setupAuthorizationHeader(config)];
                    case 1:
                        config = _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, axios_1.default.patch(url, data, config)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        error_4 = _a.sent();
                        return [2 /*return*/, error_4.response];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Get data from API
    */
    AxiosJWTDecorator.prototype.get = function (url, config, handleError, needAuthorizationHeader) {
        if (handleError === void 0) { handleError = true; }
        if (needAuthorizationHeader === void 0) { needAuthorizationHeader = true; }
        return __awaiter(this, void 0, void 0, function () {
            var config_3, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config_3 = axios_1.default.defaults;
                        if (!needAuthorizationHeader) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setupAuthorizationHeader(config_3)];
                    case 1:
                        config_3 = _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, axios_1.default.get(url, config_3)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        error_5 = _a.sent();
                        this.handleError(error_5);
                        return [2 /*return*/, error_5.response];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Get Admins
    */
    AxiosJWTDecorator.prototype.getAdmin = function (url, config, handleError, needAuthorizationHeader) {
        if (handleError === void 0) { handleError = true; }
        if (needAuthorizationHeader === void 0) { needAuthorizationHeader = true; }
        return __awaiter(this, void 0, void 0, function () {
            var config_4, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        config_4 = axios_1.default.defaults;
                        if (!needAuthorizationHeader) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.setupAuthorizationHeader(config_4)];
                    case 1:
                        config_4 = _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, axios_1.default.get(url, config_4)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        error_6 = _a.sent();
                        return [2 /*return*/, JSON.parse("false")];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
    * Get data from API anonymously
    */
    AxiosJWTDecorator.prototype.getAnonymous = function (url, config, handleError, needAuthorizationHeader) {
        if (handleError === void 0) { handleError = true; }
        if (needAuthorizationHeader === void 0) { needAuthorizationHeader = false; }
        return __awaiter(this, void 0, void 0, function () {
            var config_5, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        config_5 = axios_1.default.defaults;
                        return [4 /*yield*/, axios_1.default.get(url, config_5)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_7 = _a.sent();
                        this.handleError(error_7);
                        return [2 /*return*/, error_7.response];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AxiosJWTDecorator.prototype.putAnonymous = function (url, data, config, needAuthorizationHeader) {
        if (needAuthorizationHeader === void 0) { needAuthorizationHeader = false; }
        return __awaiter(this, void 0, void 0, function () {
            var config_6, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        config_6 = axios_1.default.defaults;
                        if (data) {
                            config_6.headers["Content-Type"] = 'application/json; charset=utf-8';
                        }
                        return [4 /*yield*/, axios_1.default.put(url, data, config_6)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_8 = _a.sent();
                        return [2 /*return*/, error_8.response];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AxiosJWTDecorator.prototype.handleError = function (error) {
        console.log("Erro abaixo:");
        console.log(error);
        if (error.hasOwnProperty("response")) {
            var errorStatus = error.response.status;
            if (errorStatus === 403) {
                //window.location.href = `/errorpage/403`;
                window.location.href = "/signin";
            }
            else if (errorStatus === 401) {
                window.location.href = "/signin";
            }
            else {
                window.location.href = "/errorpage/" + error.message;
            }
        }
        else {
            window.location.href = "/errorpage/" + error.message;
        }
    };
    /**
    * Sets authorization header in request.
    */
    AxiosJWTDecorator.prototype.setupAuthorizationHeader = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                microsoftTeams.initialize();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var authTokenRequest = {
                            successCallback: function (token) {
                                if (!config) {
                                    config = axios_1.default.defaults;
                                }
                                config.headers["Authorization"] = "Bearer " + token;
                                resolve(config);
                            },
                            failureCallback: function (error) {
                                // When the getAuthToken function returns a "resourceRequiresConsent" error, 
                                // it means Azure AD needs the user's consent before issuing a token to the app. 
                                // The following code redirects the user to the "Sign in" page where the user can grant the consent. 
                                // Right now, the app redirects to the consent page for any error.
                                console.error("Error from getAuthToken: ", error);
                                window.location.href = "/signin";
                            },
                            resources: []
                        };
                        microsoftTeams.authentication.getAuthToken(authTokenRequest);
                    })];
            });
        });
    };
    return AxiosJWTDecorator;
}());
exports.AxiosJWTDecorator = AxiosJWTDecorator;
var axiosJWTDecoratorInstance = new AxiosJWTDecorator();
exports.default = axiosJWTDecoratorInstance;
//# sourceMappingURL=axios-decorator.js.map